import * as React from 'react';
import { Dashboard } from 'app/area/dashboard/dashboard';
import styles from './dashboard.scss';
import { RouterProps } from 'app/components/enhancers/with-router';

interface DashboardRouteProps {
  router: RouterProps;
  params: { favouriteId?: string; dashboardType?: string };
}

export function DashboardRoute({
  router,
  params
}: DashboardRouteProps) {
  return (
    <div className={styles.dashboardView}>
      <Dashboard
        dashboardType={parseInt(params.dashboardType, 10)}
        requestedMainFavouriteId={parseInt(params.favouriteId, 10)}
        showDescription={true}
        location={router.location}
        editSavedFavourite={Boolean(router.location?.query?.editSavedFavourite)} />
    </div>
  );
}
